export const config = {
    backend: 'https://www.plaidhatgames.com',
    save_game_key: 'flsave',
    preload: null,
    debug: false,
    desktop: true,
};